"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "How can my business join the COHCC?",
  answer: <>
        Joining the Colorado Hispanic Chamber of Commerce is a strategic move for your business growth. Visit our{" "}
        <Link to="/JoinUsPage" className="text-primary font-medium underline underline-offset-4 hover:text-primary/80">
          Join Us
        </Link>{" "}
        page to explore membership tiers, benefits, and the application process.
      </>
}, {
  question: "Where can I access economic data and reports?",
  answer: <>
        We provide comprehensive insights into the Hispanic market's economic impact. Our{" "}
        <Link to="/IntelligencePage" className="text-primary font-medium underline underline-offset-4 hover:text-primary/80">
          Intelligence
        </Link>{" "}
        section features dashboards, research papers, and real-time metrics on purchasing power and business growth.
      </>
}, {
  question: "What leadership programs do you offer?",
  answer: <>
        We are dedicated to fostering the next generation of leaders. Our leadership initiatives are detailed under{" "}
        <Link to="/OurPillarsPage" className="text-primary font-medium underline underline-offset-4 hover:text-primary/80">
          Our Pillars
        </Link>
        , where you can find information on workshops, mentorships, and executive training.
      </>
}, {
  question: "How can I get involved in policy advocacy?",
  answer: <>
        Advocacy is central to our mission. We invite members to participate in our policy committees and events. Check our{" "}
        <Link to="/OurPillarsPage" className="text-primary font-medium underline underline-offset-4 hover:text-primary/80">
          Policy & Advocacy
        </Link>{" "}
        initiatives to see how we champion the interests of Hispanic-owned businesses at the state and federal levels.
      </>
}, {
  question: "Who can I contact for partnership opportunities?",
  answer: <>
        We welcome strategic partnerships with corporations and community organizations. Please reach out to our team via the{" "}
        <Link to="/ContactPage" className="text-primary font-medium underline underline-offset-4 hover:text-primary/80">
          Contact
        </Link>{" "}
        page to discuss collaboration opportunities.
      </>
}];
export default function CommonQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="common-questions" className="dark bg-background text-foreground py-20 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[10%] -left-[10%] w-[40%] h-[40%] bg-secondary/5 rounded-full blur-3xl" />
      </div>

      <div ref={ref} className={cn("max-w-4xl mx-auto relative z-10 transition-all duration-700 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-sans tracking-tight text-primary mb-4">
            Common Questions
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Find answers to frequent inquiries about membership, data access, and our mission to empower the Hispanic business community.
          </p>
        </div>

        <div className="bg-card/50 backdrop-blur-sm border border-primary/20 rounded-xl shadow-sm overflow-hidden">
          <Accordion type="single" collapsible className="w-full">
            {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-primary/10 px-6 last:border-b-0" data-index={i}>
                <AccordionTrigger className="text-left text-base md:text-lg font-bold font-sans text-foreground hover:text-primary hover:no-underline py-6">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}